import React from 'react';
import { Row } from 'antd';

export const Politicas = () => {
    
    return (
        <>
        <Row 
            justify="start">
            <div className="text-style">
              ByFeliz a través de Servicios de Alta Innovación de México SAPI de CV  con domicilio en Torre Cibeles Piso 7 Oficina 62, calle Planificadores #2802, colonia Empleados del SFEO. en Monterrey Nuevo León, México con CP 64480, es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.
            </div>  

            <div className="text-style">
                Los datos personales (los datos) divulgados esta Empresa, tienen como finalidad que los datos personales y/o datos sensibles, que en su caso sean recabados por virtud del presente Aviso de Privacidad, puedan ser utilizados para la debida operación y fines de la Empresa (y todas sus áreas), incluyendo su transmisión dentro y fuera del país a: instituciones educativas, socios comerciales u otros terceros y a las autoridades gubernamentales que así lo requieran; lo anterior con el objeto de que los mismos puedan ser utilizados para efectos académicos, administrativos, comerciales, mercadológicos, ventas, estadísticos y otros que puedan ser de interés y/o en beneficio del Titular.
            </div> 

            <div className="text-style">
                Con base en lo anterior, usted, al proporcionar sus datos como Titular de los mismos, otorga su consentimiento a la Empresa para que esta pueda utilizarlos para los fines aquí descritos; asimismo, queda al tanto de los derechos que usted ostenta como Titular de los datos.
            </div>

            <div className="text-style"> 
                Hacemos de su conocimiento que para cumplir con las finalidades previstas en este Aviso de Privacidad y la Ley aplicable, podrán ser recabados y tratados datos personales sensibles, los cuales pueden relacionarse a su esfera más íntima, tales como aspectos de origen racial o étnico, estado de salud, creencias religiosas, filosóficas y morales, opiniones políticas, entre otras.
            </div> 

            <div className="text-style">
                Con base en lo anterior, nos comprometemos a que los mismos serán tratados bajo estrictas medidas de seguridad y garantizando su confidencialidad.
            </div>

            <div className="text-style">
                Para las finalidades indicadas en el presente Aviso de Privacidad, la empresa puede recabar sus datos personales de la siguiente manera:
            </div>

            <ul>
                <li className="text-style no-padding">Proporcionados directamente por el Titular de los datos.</li>
                <li className="text-style no-padding">Obtenidas a través de otras fuentes permitidas por Ley.</li>
                <li className="text-style no-padding">Por visitas al sitio de Internet de la Institución o el uso de sus servicios en línea.</li>
            </ul>
        </Row>
        
        <Row>
            <h1 className="politicas">Cookies y Web Beacons</h1>
            <div className="text-style">
                Cabe mencionar, que al acceder a sitios de internet se podrán encontrar con “cookies”, que son archivos de texto que se descargan automáticamente y son almacenados en el disco duro del equipo de cómputo del usuario al navegar una página de internet específica, los cuales permiten grabar en el servidor de Internet algunos de sus datos.
            </div>

            <div className="text-style">
                Igualmente, las páginas de Internet pueden contener “web beacons”, que son imágenes insertadas en la página o correo electrónico, que pueden ser utilizadas para monitorear el comportamiento de un visitante, así como para almacenar información sobre la dirección IP del usuario, duración del tiempo de interacción de dicha página y el tipo de navegador utilizado, entre otros.
            </div>

            <div className="text-style">
                En virtud de lo anterior, le informamos que la Institución pudiera utilizar “cookies” y “web beacons” para un mejor desempeño del sitio.
            </div>

            <div className="text-style">
                Estas “cookies” y otras tecnologías pueden ser deshabilitadas en las opciones de configuración del navegador que se esté usando.
            </div>

            <div className="text-style">
                Esta declaración está sujeta a los términos y condiciones de todos los sitios web de la Empresa antes descritos, lo cual constituye un acuerdo legal entre el usuario y la Empresa. Si el Titular utiliza los servicios en cualquiera de los sitios de la Empresa, significa que ha leído, entendido y aceptado los términos antes expuestos. Si no está de acuerdo con ellos, el Titular no deberá proporcionar información personal, ni utilizar los servicios de los sitios de la institución.
            </div>

            <div className="text-style">
                En el caso de empleo de cookies, el botón de
            </div>

            <div className="text-style">
                La seguridad y la confidencialidad de los datos que los usuarios proporcionen estarán protegidos por un servidor seguro bajo el protocolo Secure Socket Layer (SSL), de tal forma que los datos enviados se transmitirán encriptados para asegurar su resguardo.
            </div>

            <div className="text-style">
                Para verificar que se encuentra en un entorno protegido asegúrese de que aparezca una S en la barra de navegación (Ejemplo: httpS://.) Sin embargo, y a pesar de contar cada día con herramientas más seguras, la protección de los datos enviados a través de Internet no se puede garantizar al 100%; por lo que una vez recibidos, se hará todo lo posible por salvaguardar la información.
            </div>
        </Row>
        
        <Row>
            <h1 className="politicas">Políticas de devolución</h1>
                <div className="text-style">
                    <u className="text-style no-padding">¿Cuánto tiempo se tiene para solicitar la devolución?</u>
                    <ul>
                    <li className="text-style no-padding">
                        El tiempo máximo para solicitar la cancelación es de 48 HORAS una vez que se haya validado y efectuado el pago.
                    </li>
                    </ul>
                    <u className="text-style no-padding">¿En qué casos aplica esta política?</u>
                    <ul>
                    <li className="text-style no-padding">
                        El sistema NO cobrará al usuario si el reporte individual de CUALQUIER de nuestros test no se haya generado por completo.
                    </li>
                    <li className="text-style no-padding">
                        En caso de que el usuario no haya tenido acceso a los resultados de nuestra plataforma y SE HAYA HECHO EL CARGO.
                    </li>
                    </ul>

                    <u className="text-style no-padding">¿Existe posibilidad de devolución en caso de inconformidad de los resultados?</u>
                    <ul>
                    <li className="text-style no-padding">
                        No procede la devolución en este caso, ya que los resultados arrojados en el sistema son en base a lo señalado por el usuario y estos pueden ser susceptibles.
                    </li>
                    </ul>

                    <u className="text-style no-padding">¿Qué hacer en estos casos?</u>
                    <ul>
                    <li className="text-style no-padding">
                        Al haberse percatado del problema y ver que efectivamente es candidato para la devolución, ponerse en contacto con nosotros en cualquiera de los siguientes medios:
                    </li>
                    <ul className="check-list">
                        <li className="text-style no-padding">Teléfono: +52(81)421-0022</li>
                        <li className="text-style no-padding">Por medio del chat desde el portal, este se encuentra en la parte inferior derecha de los portales.</li>
                        <li className="text-style no-padding">Por correo en <a href="mailto:admin@iivvo.com">admin@iivvo.com</a></li>
                    </ul>
                    </ul>

                    <u className="text-style no-padding">¿Qué información se debe de proporcionar para levantar la queja por vía correo electrónico?</u>
                    <ul>
                    <li className="text-style no-padding">Nombre completo</li>
                    <li className="text-style no-padding">Usuario</li>
                    </ul>

                    <u className="text-style no-padding">¿Cuál es el horario de atención a clientes?</u>
                    <ul>
                    <li className="text-style no-padding">De Lunes a Viernes de 8:30 am a 2:00 pm y de 3:00 pm a 6:00 pm</li>
                    </ul>

                    <u className="text-style no-padding">¿Cuánto es el porcentaje de devolución que se da?</u>
                    <ul>
                    <li className="text-style no-padding">Se hace la devolución del monto COMPLETO. Condicionado que efectivamente se haya hecho el cargo.</li>
                    </ul>

                    <u className="text-style no-padding">¿En cuánto tiempo se hace la devolución?</u>
                    <ul>
                    <li className="text-style no-padding">Una vez que sea validada la devolución de parte iiVVO.com y psicometricos.com será en un máximo de 72 horas.</li>
                    <li className="text-style no-padding">En caso que usuario haya realizado el pago en una tiendo de autoservicio es importante que proporcione el número de cuenta para realizar la devolución.</li>
                    </ul>

                    <u className="text-style no-padding">¿Cómo manejan el tipo de cambio de divisas?</u>
                    <ul>
                    <li className="text-style no-padding">El cobro del servicio se hace en dólares, por lo tanto los precios son al tipo de cambio del día y de manera automática el sistema lo cambiará a la moneda del país.</li>
                    </ul>

                    <u className="text-style no-padding">¿Qué hacer en caso de controversia?</u>
                    <ul>
                    <li className="text-style no-padding">Los canales de comunicación están abiertos, nuestra política de devolución está dirigida a que el usuario no tenga complicaciones en caso de errores de la empresa.</li>
                    </ul>

                    Esta política está elaborada en base a la Ley Federal de Protección al Consumidor en su artículo 76 bis II fracciones III, IV, V y demás aplicables
                </div>
        </Row>
        
        <Row>
            <h1 className="politicas">Sobre Promociones, Ofertas y Servicios</h1>
            <div className="text-style">
                Nuestro programa publicitario de notificación de promociones, ofertas y servicios a través de correo electrónico, se realiza mediante mensajes promocionales de la Empresa y, ocasionalmente, podrán incluirse ofertas de terceras partes que sean nuestros socios comerciales. Los correos electrónicos sólo serán enviados a los usuarios y a aquellos contactos registrados. Esta indicación podrá ser modificada en cualquier momento a través de los correos electrónicos enviados.
            </div>

            <div className="text-style">
                En todo momento usted podrá revocar el consentimiento que nos ha otorgado para el tratamiento de sus datos personales y/o sensibles, en su caso, a fin de que dejemos de hacer uso de los mismos.
            </div>
        </Row>
        
        <Row>
            <h1 className="politicas">Ejercicio de Derechos A.R.C.O.</h1>
            <div className="text-style">
                En caso de que desee ejercer sus derechos A.R.C.O. (acceder, rectificar, cancelar u oponerse al uso de sus datos personales) respecto a los datos que conforman la base de datos de la Institución, deberá cumplir con los siguientes requisitos:
            </div>

            <div className="text-style">
                El Titular, o su representante legal debidamente acreditado, deberá Enviar una solicitud, por escrito al Departamento Legal de la empresa. Dicha solicitud deberá contener: Nombre, domicilio, teléfono o correo electrónico del Titular y una descripción clara y precisa de los datos personales respecto de los que se busca ejercer alguno de los derechos mencionados.
            </div>
            <div className="text-style">
                La Solicitud deberá acompañar los documentos que acrediten la Titularidad de los datos, y/o los documentos que lo acrediten como padre, tutor o representante legal del Titular; asimismo, deberá acompañar cualquier otro documento que facilite la localización de sus datos personales.
                En un plazo que no excederá de los 30 días hábiles, se dará respuesta al Titular de los datos en la oficina en donde ingresó la solicitud correspondiente.
            </div>
            <div className="text-style">
                Para el caso de los datos personales recabados en las oficinas corporativas, se deberá dirigir el escrito al Titular del Área Administrativa que corresponda, el cual dará atención a la solicitud en los términos aquí descritos.
                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones al presente Aviso de Privacidad, para la atención de novedades legislativas, jurisprudenciales, políticas internas, nuevos requerimientos solicitados por la empresa, entre otras.
            </div>

            <div className="text-style">
                Estas modificaciones estarán disponibles al público a través de los siguientes medios: la página de internet de la Empresa es www.iivvo.com
            </div>

            <div className="text-style">
                Igualmente le notificamos que este Aviso de Privacidad fue modificado el día 13 de Febrero de 2015.
            </div>
        </Row>
        </>
    )
}
